'use es6';

import { HUBL_CSS, HUBL_HTML, HUBL_JS, CSS as TEMPLATE_FILE_TYPE_CSS, HTML, JS, JSON as TEMPLATE_FILE_TYPE_JSON, TXT, MD, MAP } from 'DesignData/constants/TemplateFileTypes';
/**
 * Maps DesignData/enum/TemplateFileTypes to CodeMirror modes.
 * @type {Object.<TemplateFileTypes, Modes>}
 */

export default Object.freeze({
  [HUBL_CSS]: 'text/x-hubl-css',
  [HUBL_HTML]: 'text/x-hubl-html',
  [HUBL_JS]: 'text/x-hubl-javascript',
  [TEMPLATE_FILE_TYPE_CSS]: 'text/css',
  [HTML]: 'text/html',
  [JS]: 'text/javascript',
  [TEMPLATE_FILE_TYPE_JSON]: 'application/json',
  [TXT]: 'text/plain',
  [MD]: 'text/x-markdown',
  [MAP]: 'application/json'
});